<template>
    <div class="withdraw_container">
        <div class="channel_container">
            <WithdrawViewTwo ref="withdrawRef" v-model:data-set-two="dataSetTwo"
                @confirm-withdraw-popup="confirmWithdrawUserId" @input-value-change="inputValueChange"
                @select-channel="selectChannel" @select-tab-type="selectTabType"
                @update-form-values="updateWithdrawFormValues" @change-value="changeValues"
                @check-fields-fill="checkFieldsFill" />
        </div>
        <div class="channel_container">
            <div class="channel_text">{{ $t('common.paymentChannel') }}：</div>
            <div class="channel_list">
                <div class="channel_card" v-for="item in dataSet.channelList" :key="item.name"
                    :class="dataSet.activeChannel.id == item.id ? 'active_channel' : ''" @click="selectChannel(item)">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div>
            <div class="channel_container">
                <div style="padding: 0 10px;">
                    <InputField :modelValue="dataSet?.selectedAmount" :labelText="$t('withdraw.valueLabel')"
                        @valueChanged="inputValueChange" />
                    <div class="fee-total-row">
                        <span class="fee-text">
                            {{ $t('withdraw.withdrawFee') }}:
                            <span class="currency">R$</span>
                            <span class="highlight">{{ formatCurrency(selectedAmount || 0) }}</span>
                        </span>
                        <span class="total-text">
                            {{ $t('withdraw.totalToReceive') }}:
                            <span class="currency">R$</span>
                            <span class="highlight">{{ formatCurrency(dataSet?.balanceAmount || 0) }}</span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="btn_container">
                <MainButton :title="$t('common.sake')" :activeStatus="isMainButtonActive"
                    @click="withdrawRef?.confirmWithdraw()" />

            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, computed, onMounted, reactive } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData, WithdrawViewData } from '@/view/withdraw/supportScript';
import WithdrawViewTwo from './withdrawPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import { useUserStore } from '@/stores/user';
import { withdraw, withdrawSettingByUserID } from '@/api/withdraw';
import MainButton from '../components/common/mainButton.vue';
const emits = defineEmits(['selectChannel', 'showError', 'showSuccess', 'showLoading'])
const withdrawStore = useWithdrawStore()
const userStore = useUserStore()
const uId = computed(() => userStore.id)
const props = defineProps<{
    dataSet: WithdrawViewData
}>()
const withdrawRef = ref<InstanceType<typeof WithdrawViewTwo>>()
const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(true)
const showEmaiIdError = ref(true)
const showPhoneIdError = ref(true)
const showEvpIdError = ref(true)
const showCPFNumError = ref(false)
const activeButton = ref(false)
const isActiveButton = ref(false)
const selectedAmount = ref(0)
const isDisabled = ref(false)

const formValues = ref({
    cpfID: '',
    emailID: '',
    phoneID: '',
    evpID: '',
    userName: '',
    cpfNumber: '',
    brazilID: '',
    bank: '',
})

const dataSetTwo = reactive<WithdrawPopupData>({
    // show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
})

const isMainButtonActive = computed(() => activeButton.value && isActiveButton.value)

const updateWithdrawFormValues = (values: any) => {
    formValues.value = { ...formValues.value, ...values }
}

const selectChannel = (item: PayChannel) => {
    emits('selectChannel', item)
}



const selectTabType = (item: any) => {
    activeTab.value = item
}

const confirmWithdrawUserId = () => {
    const data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then((res) => {
            confirmWithdrawApi()
        })
        .catch((err) => {
            emits('showError', err)
        })
}

const confirmWithdrawApi = () => {
    emits('showLoading', true)
    const active = activeTab.value.name

    const data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: selectedAmount.value,
        tax_type: active,
        tax_id:
            active === 'CPF'
                ? formValues.value.cpfID
                : active === 'E-mail'
                    ? formValues.value.emailID
                    : active === 'PHONE'
                        ? formValues.value.phoneID
                        : active === 'EVP'
                            ? formValues.value.evpID
                            : '',
        account_name: formValues.value.userName,
        cpf_id: formValues.value.cpfNumber,
        uid: uId.value,
    }

    if (selectedChannel.value.name === 'winwinpay') {
        data.bank_name = formValues.value.bank
    } else if (selectedChannel.value.name === 'uupay') {
        data.bank_name = formValues.value.bank
        data.identity_no = formValues.value.brazilID
    }

    withdraw(data)
        .then((res) => {
            emits('showLoading', false)
            emits('showSuccess', res.msg)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
        .catch((err) => {
            emits('showLoading', false)
            emits('showError', err)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
} 

const getWithdrawDetails = () => {
  let data = { uid: uId.value }
  withdrawSettingByUserID(data)
    .then(res => {
      const resData = res.data
      if(resData == null) return
      withdrawStore.setWithdrawInfo(resData)
      dataSetTwo.cpfID = resData?.cpf || ''
      dataSetTwo.emailID = resData?.email || ''
      dataSetTwo.phoneID = resData?.phone || ''
      dataSetTwo.evpID = resData?.evpId || ''
      dataSetTwo.userName = resData?.userName || ''
      dataSetTwo.cpfNumber = resData?.cpfId || ''
      dataSetTwo.brazilID = resData?.identityNo || ''
      dataSetTwo.isDisabled = resData?.isEditable == 1
    })
     .catch((err) => {       
            emits('showError', err)
    })
}

const changeValues = (data: any) => {
    if(data.type === 'cpfID'){
        cpfID.value = data.value
    }else if(data.type === 'emailID'){
        emailID.value = data.value
    }else if(data.type === 'phoneID'){
        phoneID.value = data.value
    }else if(data.type === 'evpID'){
        evpID.value = data.value
    }else if(data.type === 'cpfNumber'){
        cpfNumber.value = data.value
    }else if(data.type === 'userName'){
        userName.value = data.value
    }else if(data.type === 'brazilID'){
        brazilID.value = data.value
    }else if(data.type === 'bank'){
        bank.value = data.value
    }
}

const checkFieldsFill = (isActive: any) =>{
    isActiveButton.value = isActive
}

const inputValueChange = (val: any) => {
    const currentBalance = props.dataSet?.balanceAmount ?? 0
    if (currentBalance < val) {
        selectedAmount.value = currentBalance
    } else {
        selectedAmount.value = val
    }
    if (val > 0 && isActiveButton.value) {
        activeButton.value = true
    } else {
        activeButton.value = false
    }
}

onMounted(() => {
    getWithdrawDetails()
})
</script>
<style scoped>
.withdraw_container {
    padding: 0 !important;
    margin: 0px 0px 50px 0px !important;
}

.channel_text {
    color: #f1bae0;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 10px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 25px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}


.line {
    margin-top: 5px;
    height: 0.5px;
    width: 100%;
    background: rgba(255, 255, 255, 0.25);
    ;
}

.btn_container {
    padding: 30px 0px;
}

.balance_container {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 3vh;
}

.balance_text {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.65);
}

.balance_value {
    color: rgba(255, 255, 255, 0.85);
    font-size: 45px;
}

.sub_container {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.top-banner {
    padding: 5px 15px;
}

.top-banner img {
    width: 100%;
    border-radius: 20px;
}

.channel_container {
    /* background-color: #3e2e4b; */
    font-size: 14px;
    border-radius: 10px;
}

.channel_list {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 10px 10px 10px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    background: #40294f;
    color: #8b6e8b;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 4px;
    margin-right: 10px;
    font-size: 13px;
    height: 30px;
    width: 100%;
}

.active_channel {
    background: #ff49a3;
    color: #ffffff;
    border-radius: 5px;
    width: 100%;
}

.amount-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px 10px;
    font-size: 13px;
    color: #ffffffb3;
    /* soft white */
}

.fee-total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    padding: 0 4px;
    font-size: 13px;
    font-weight: 600;
    color: #a77fd4;
    /* soft purple text */
}

.currency {
    color: #ffb14a;
    /* gold for "R$" */
    margin-left: 4px;
    font-weight: bold;
}

.highlight {
    color: #ffb14a;
    /* gold for amount */
    margin-left: 2px;
    font-weight: bold;
}

@media (max-width: 450px) {
    .fee-total-row {
        font-size: 11px;
        /* smaller font for mobile */
    }

    .fee-total-row .currency,
    .fee-total-row .highlight {
        font-size: 11px;
        /* adjust R$ and amount font if needed */
    }
}

@media (min-width: 1440px) {
    .channel_text {
        font-size: 3vh;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }

    .active_channel {
        padding: 15px 3vh !important;
    }
}

@media (min-width: 1920px) {
    .channel_text {
        font-size: 3vh;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }

    .active_channel {
        padding: 15px 3vh !important;
    }
}
</style>